import React from 'react';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '../ui/dialog';
import { Input } from '../ui/input';

const ActionConfirmationDialog = ({
  dialogOpen,
  handleClose,
  handleConfirm,
  actionType,
  comments,
  setComments
}) => {
  return (
    <Dialog open={dialogOpen} onOpenChange={handleClose}>
      <DialogContent className='bg-white'>
        <DialogHeader>
          <DialogTitle className='text-orange-600 border-b border-gray-300 '>
            Confirm {actionType}
          </DialogTitle>
        </DialogHeader>
        <div className='mt-4'>
          <Input
            autoFocus
            className='mt-4'
            placeholder='Comments'
            rows={4}
            value={comments}
            onChange={e => setComments(e.target.value)}
          />
        </div>
        <DialogFooter className='pt-4'>
          <Button variant='outline' onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant='default'
            className='bg-orange-600 hover:bg-orange-600/90 text-white'
            onClick={handleConfirm}
          >
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ActionConfirmationDialog;
